import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/views/login/Login.vue"),
    meta: {
      title: "",
      requiresVisitor: true,
    },
  },
  {
    path: "/callback",
    name: "AuthCallback",
    component: () => import("@/views/auth-callback/AuthCallback.vue"),
    meta: {
      title: "Auth callback",
      requiresVisitor: true,
    },
  },
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/401/401.vue"),
    meta: {
      title: "Something went wrong",
      requiresAuth: true,
    },
  },
  {
    path: "/2-fa-authenticate/",
    name: "2FAAuthenticate",
    component: () => import("@/views/2-fa-authenticate/2FAAuthenticate.vue"),
    meta: {
      title: "You need to authenticate",
      requiresVisitor: true,
    },
  },
];